/*
 * Module for the IRS 1099-R Print job criteria page
 */
rs.module("content/jobs/criteria/irs1099rprint",

    [
        "controls/data/grid",
        "common/select-helper",
        "common/visibility"
    ],

    function (gridModule, selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, backendUrls, codeValues, modes, produceTypes, testTypes, outputTypes, printRanges, printerLists, preferredPrinter, benefitPaymentGridLrsApi, searchControl) {

            // Unpack JS selectors
            var criteria = $.js(jsSelectors.criteria);

            var taxYearSelect = criteria.js(jsSelectors.taxYearSelect);
            var modeRadioContainer = criteria.js(jsSelectors.modeRadioContainer);
            var produceTypeSelect = criteria.js(jsSelectors.produceTypeSelect);
            var testTypeSelect = criteria.js(jsSelectors.testTypeSelect);
            var outputTypeSelect = criteria.js(jsSelectors.outputTypeSelect);
            var formSelect = criteria.js(jsSelectors.formSelect);
            var formSelectLoadingSpinner = criteria.js(jsSelectors.formSelectLoadingSpinner);
            var printStatusSelect = criteria.js(jsSelectors.printStatusSelect);
            var lastPrintedDateSelect = criteria.js(jsSelectors.lastPrintedDateSelect);
            var lastPrintedDateLoadingSpinner = criteria.js(jsSelectors.lastPrintedDateLoadingSpinner);
            var printRangeContainer = criteria.js(jsSelectors.printRangeContainer);
            var printRangeRadioContainer = criteria.js(jsSelectors.printRangeRadioContainer);
            var printNameRangeContainer = criteria.js(jsSelectors.printNameRangeContainer);
            var lastNameFromInput = criteria.js(jsSelectors.lastNameFromInput);
            var lastNameToInput = criteria.js(jsSelectors.lastNameToInput);
            var horizontalAdjustmentInput = criteria.js(jsSelectors.horizontalAdjustmentInput);
            var verticalAdjustmentInput = criteria.js(jsSelectors.verticalAdjustmentInput);
            var printOneContainer = criteria.js(jsSelectors.printOneContainer);
            var gridContainer = criteria.js(jsSelectors.gridContainer);
            var searchControlLoadingSpinner = criteria.js(jsSelectors.searchControlLoadingSpinner);
            var quantityContainer = criteria.js(jsSelectors.quantityContainer);
            var quantityInput = criteria.js(jsSelectors.quantityInput);
            var printerSelect = criteria.js(jsSelectors.printerSelect);
            var sortOrderSelect = criteria.js(jsSelectors.sortOrderSelect);
            var formContainer = criteria.js(jsSelectors.formContainer, { multiple: true });
            var includeEmailRecipientsCheckbox = criteria.js(jsSelectors.includeEmailRecipientsCheckbox);
            var maskTinCheckbox = criteria.js(jsSelectors.maskTinCheckbox);

            // Build select helper(s) to expand drop down functionality.
            var produceTypeSelectHelper = selectHelper.getHelper(produceTypeSelect);
            var testTypeSelectHelper = selectHelper.getHelper(testTypeSelect);
            var outputTypeSelectHelper = selectHelper.getHelper(outputTypeSelect);
            var formSelectHelper = selectHelper.getHelper(formSelect);
            var printStatusSelectHelper = selectHelper.getHelper(printStatusSelect);
            var lastPrintedDateSelectHelper = selectHelper.getHelper(lastPrintedDateSelect);
            var printerSelectHelper = selectHelper.getHelper(printerSelect);
            var sortOrderSelectHelper = selectHelper.getHelper(sortOrderSelect);

            // Setup listener(s) on inputs to perform actions
            modeRadioContainer.find("input").on("click", () => modeChanged());
            taxYearSelect.change(() => taxYearChanged());
            produceTypeSelect.change(() => produceTypeChanged());
            testTypeSelect.change(() => testTypeChanged());
            outputTypeSelect.change(() => outputTypeChanged());
            formSelect.change(() => toggleAdjustmentFields());
            printStatusSelect.change(function () { setLastPrintDateSelect(modeRadioContainer.find("input:checked").val()); });
            printRangeRadioContainer.find("input").on("click", () => printRangeChanged());

            // Listen for a participant to be selected from the search control, and repopulate benefit claim payments
            searchControl.onSelectionComplete(function (accountPartyKey) {
                populateBenefitGrid(accountPartyKey);
                visibility.show(gridContainer);
            });

            // Listen for the search control to be cleared, and repopulate benefit claim payments
            searchControl.onSelectionCleared(function () {
                populateBenefitGrid();
                visibility.hide(gridContainer);
            });

            // Handle the Tax Year changed event
            function taxYearChanged() {
                var mode = modeRadioContainer.find("input:checked").val();
                var produce = produceTypeSelect.val();
                var output = outputTypeSelect.val();

                // Update relevant fields
                setFormSelect(produce, output);
                setLastPrintDateSelect(mode);
                setMaskTinCheckbox(produce);
            }

            // Handle the mode changed event
            function modeChanged() {
                var mode = modeRadioContainer.find("input:checked").val();

                // Set Produce, Test, and Output select drop downs
                setProduceSelect(mode);
                setTestTypeSelect(mode);
                setOutputTypeSelect(mode, produceTypeSelect.val(), testTypeSelect.val());

                var output = outputTypeSelect.val();
                var produce = produceTypeSelect.val();
                var test = testTypeSelect.val();
                setAllFields(mode, produce, test, output);
            }

            // Handle the Produce type changed event
            function produceTypeChanged() {
                var mode = modeRadioContainer.find("input:checked").val();
                var output = outputTypeSelect.val();
                var produce = produceTypeSelect.val();
                var test = testTypeSelect.val();

                visibility.setVisible(formContainer, produceTypeSelect.val() != produceTypes.instructions)

                // Update all fields effected by changing the produce type select
                setOutputTypeSelect(mode, produce, test);
                setFormSelect(produce, output);
                setPrintStatusSelect(produce, test);
                togglePrintRangeVisibility(mode, produce, test);
                toggleQuantity(mode, produce);
                setSortOrderSelect(mode, produce, test);
                setIncludeEmailRecipientsCheckbox(mode, produce);
                setMaskTinCheckbox(produce);
            }

            // Handle the Test type changed event
            function testTypeChanged() {
                var mode = modeRadioContainer.find("input:checked").val();
                var produce = produceTypeSelect.val();
                var test = testTypeSelect.val();
                var output = outputTypeSelect.val();

                // Update all fields effected by changing the test type select
                setOutputTypeSelect(mode, produce, test);
                setFormSelect(produce, output);
                setPrintStatusSelect(produce, test);
                togglePrintRangeVisibility(mode, produce, test);
                setSortOrderSelect(mode, produce, test);
            }

            // Handle the Output type changed event
            function outputTypeChanged() {
                var output = outputTypeSelect.val();
                var test = testTypeSelect.val();
                var produce = produceTypeSelect.val();

                // Update all fields effected by changing the output type select
                setFormSelect(produce, output);
                togglePrinterSelect(produce, test, output);
            }

            // Handle the Print Range Radio button change event
            function printRangeChanged() {

                // Get selected radio button
                var printRange = printRangeRadioContainer.find("input:checked").val();

                // Set visibility of what has been selected
                visibility.setVisible(printNameRangeContainer, printRange == printRanges.range);
                visibility.setVisible(printOneContainer, printRange == printRanges.one);

                // Clear Inputs
                [
                    lastNameFromInput,
                    lastNameToInput
                ].forEach((input) => input.clearErrors().val(''));

                // clear the search control, which will also clear the grid (since we're handling onSelectionCleared above)
                searchControl.clear();
            }

            // Populate Benefit Grid (accountPartykey is optional)
            function populateBenefitGrid(accountPartyKey) {
                searchControlLoadingSpinner.show();
                gridModule.update(
                    backendUrls.getBenefitGridByAccountParty,

                    { accountPartyKey: accountPartyKey },

                    benefitPaymentGridLrsApi.agGridApi,

                    function done(gridUpdate) {
                        searchControlLoadingSpinner.hide();
                    }
                );
            }

            // Helper method to resolve all fields after switching mode
            function setAllFields(mode, produce, test, output) {

                setFormSelect(produce, output);
                setPrintStatusSelect(produce, test);
                setLastPrintDateSelect(mode);
                toggleAdjustmentFields();
                togglePrintRangeVisibility(mode, produce, test);
                toggleQuantity(mode, produce);
                togglePrinterSelect(produce, test, output);
                setSortOrderSelect(mode, produce, test);
                setIncludeEmailRecipientsCheckbox(mode, produce);
                setMaskTinCheckbox(produce);

                visibility.setVisible(formContainer, produce != produceTypes.instructions)
            }

            // Resolve the Produce type select field
            function setProduceSelect(mode) {
                if (mode == modes.create) {
                    produceTypeSelectHelper.setDisabled(false);
                }
                else if (mode == modes.reCreate || mode == modes.test) {
                    produceTypeSelectHelper.setValue(produceTypes.forms);
                    produceTypeSelectHelper.setDisabled(true);
                }
                else {
                    console.error("produce select error");
                }

                // Clear errors
                produceTypeSelect.clearErrors();
            }

            // Resolve the Test type select field
            function setTestTypeSelect(mode) {
                if (mode == modes.test) {
                    testTypeSelectHelper.setValue(testTypes.single);
                    testTypeSelectHelper.removeEmptyOption();
                    testTypeSelectHelper.setDisabled(false);
                }
                else if (mode == modes.create || mode == modes.reCreate) {
                    testTypeSelectHelper.setValue('');
                    testTypeSelectHelper.setDisabled(true);
                }
                else {
                    console.error("Test Type select error");
                }

                // Clear errors
                testTypeSelect.clearErrors();
            }

            // Resolve the Output type select field
            function setOutputTypeSelect(mode, produce, test) {

                if ((mode == modes.create && produce == produceTypes.instructions) ||
                    (mode == modes.test && test == testTypes.single)) {
                    outputTypeSelectHelper.setValue(outputTypes.print);
                    outputTypeSelectHelper.setDisabled(true);
                }
                else {
                    outputTypeSelectHelper.setDisabled(false);
                }

                // Clear errors
                outputTypeSelect.clearErrors();

                // Printer Name dependent on output type
                // (produce, test, output)
                togglePrinterSelect(produce, test, outputTypeSelect.val());
            }

            // Resolve the Form select field
            function setFormSelect(produce, output) {

                if (produce == produceTypes.forms) {
                    if (output == outputTypes.print) {

                        formSelectLoadingSpinner.show();

                        formSelectHelper.setDisabled(false);
                        formSelectHelper.removeEmptyOption();

                        formSelectHelper.loadOptionsFrom(
                            backendUrls.loadFormOptions,
                            { taxYear: taxYearSelect.val(), produceType: produce },
                            null, // special options
                            function () {
                                formSelectLoadingSpinner.hide();
                            });
                    }
                    else if (output == outputTypes.file) {

                        formSelectHelper.setValue('');
                        formSelectHelper.setDisabled(true);
                    }
                }
                else if (produce == produceTypes.instructions) {

                    formSelectLoadingSpinner.show();

                    formSelectHelper.setDisabled(false);
                    formSelectHelper.removeEmptyOption();

                    formSelectHelper.loadOptionsFrom(
                        backendUrls.loadFormOptions,
                        { taxYear: taxYearSelect.val(), produceType: produce },
                        null, // special options
                        function () {
                            formSelectLoadingSpinner.hide();
                        });
                }

                // Clear errors
                formSelect.clearErrors();

                // The adjustment alignment fields are dependent on the selected form type.
                toggleAdjustmentFields();
            }

            // Resolve Print Status field
            function setPrintStatusSelect(produce, test) {
                if (produce == produceTypes.forms) {
                    if (test == testTypes.single) {
                        printStatusSelectHelper.setValue('');
                        printStatusSelectHelper.setDisabled(true);
                    }
                    else {
                        printStatusSelectHelper.setValue(codeValues.original);
                        printStatusSelectHelper.removeEmptyOption();
                        printStatusSelectHelper.setDisabled(false);
                    }
                }
                else if (produce == produceTypes.instructions) {
                    printStatusSelectHelper.setValue('');
                    printStatusSelectHelper.setDisabled(true);
                }
                else {
                    console.error("Print Status Error");
                }

                // Clear errors
                printStatusSelect.clearErrors();
            }

            // Resolve Print Date field
            function setLastPrintDateSelect(mode) {
                if (mode == modes.create || mode == modes.test) {

                    lastPrintedDateSelectHelper.setValue('');
                    lastPrintedDateSelectHelper.setDisabled(true);
                }
                else if (mode == modes.reCreate) {

                    lastPrintedDateLoadingSpinner.show();

                    lastPrintedDateSelectHelper.setDisabled(false);

                    lastPrintedDateSelectHelper.loadOptionsFrom(
                        backendUrls.loadLastPrintedDateOptions,
                        { taxYear: taxYearSelect.val(), printStatus: printStatusSelect.val() },
                        null, // special options
                        function () {
                            lastPrintedDateLoadingSpinner.hide();
                        });
                }
                else {
                    console.error("last print date error");
                }

                // Clear errors
                lastPrintedDateSelect.clearErrors();
            }

            // Resolve the horizontal and vertical adjustment fields
            function toggleAdjustmentFields() {

                // Determine if form name includes "Pre-Printed"
                var prePrinted = formSelect.find(":selected").text().toUpperCase().includes("PRE-PRINTED");

                horizontalAdjustmentInput.prop("disabled", !prePrinted).clearErrors();
                verticalAdjustmentInput.prop("disabled", !prePrinted).clearErrors();
                if (!prePrinted) {
                    horizontalAdjustmentInput.val('');
                    verticalAdjustmentInput.val('');
                }
            }

            // Resolve the print range fields
            function togglePrintRangeVisibility(mode, produce, test) {
                if (mode == modes.create) {
                    if (produce == produceTypes.instructions) {
                        visibility.hide(printRangeContainer);
                    }
                    else {
                        visibility.show(printRangeContainer);
                    }
                }
                else if (mode == modes.reCreate) {
                    visibility.show(printRangeContainer);
                }
                else if (mode == modes.test) {
                    if (test == testTypes.single) {
                        visibility.hide(printRangeContainer);
                    }
                    else if (test == testTypes.batch) {
                        visibility.show(printRangeContainer);
                    }
                }
                else {
                    console.error("last print date error");
                }

                // When it becomes visible or not, set the ranges.
                printRangeChanged();
            }

            // Resolve the Quantity field
            function toggleQuantity(mode, produce) {
                if (mode == modes.create && produce == produceTypes.instructions) {
                    visibility.show(quantityContainer);
                }
                else {
                    visibility.hide(quantityContainer);
                    quantityInput.val('').clearErrors();
                }
            }

            // Resolve the Printer field
            function togglePrinterSelect(produce, test, output) {
                if (output == outputTypes.print) {

                    if (produce == produceTypes.instructions || test == testTypes.single) {
                        printerSelectHelper.replaceOptions(printerLists.noPdfPrinter);
                    }
                    else {
                        printerSelectHelper.replaceOptions(printerLists.allPrinters);
                    }

                    // Since we have reloaded options, we should again default to the user's preferred Printer
                    if (preferredPrinter != '') {
                        printerSelectHelper.setValue(preferredPrinter);
                    }

                    printerSelectHelper.setDisabled(false);
                }
                else if (output == outputTypes.file) {
                    printerSelectHelper.clearOptions();
                    printerSelectHelper.setDisabled(true);
                }
                else {
                    console.error("printer select error");
                }

                // Clear errors
                printerSelect.clearErrors();
            }

            // Resolve the sort order field
            function setSortOrderSelect(mode, produce, test) {
                if (mode == modes.create) {
                    if (produce == produceTypes.instructions) {
                        sortOrderSelectHelper.setValue('');
                        sortOrderSelectHelper.setDisabled(true);
                    }
                    else {
                        sortOrderSelectHelper.setDisabled(false);
                        sortOrderSelectHelper.removeEmptyOption();
                    }
                }
                else if (mode == modes.reCreate) {
                    sortOrderSelectHelper.setDisabled(false);
                    sortOrderSelectHelper.removeEmptyOption();
                }
                else if (mode == modes.test) {
                    if (test == testTypes.single) {
                        sortOrderSelectHelper.setValue('');
                        sortOrderSelectHelper.setDisabled(true);
                    }
                    else if (test == testTypes.batch) {
                        sortOrderSelectHelper.setDisabled(false);
                        sortOrderSelectHelper.removeEmptyOption();
                    }
                }
                else {
                    console.error("last print date error");
                }

                // Clear errors
                sortOrderSelect.clearErrors();
            }

            // Resolve the Include Email Recipient checkbox
            function setIncludeEmailRecipientsCheckbox(mode, produce) {
                if (mode == modes.create && produce == produceTypes.forms) {
                    includeEmailRecipientsCheckbox.prop('disabled', false);
                }
                else {
                    includeEmailRecipientsCheckbox.prop('checked', true);
                    includeEmailRecipientsCheckbox.prop('disabled', true);
                }
            }

            // Resolve the Mask TIN checkbox
            function setMaskTinCheckbox(produce) {
                if (produce == produceTypes.forms && taxYearSelect.val() >= 2013) {
                    maskTinCheckbox.prop('disabled', false);
                }
                else if (produce == produceTypes.instructions && taxYearSelect.val() >= 2013)
                {
                    maskTinCheckbox.prop('checked', true);
                    maskTinCheckbox.prop('disabled', true);
                }
                else {
                    maskTinCheckbox.prop('checked', false);
                    maskTinCheckbox.prop('disabled', true);
                }
            }

        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);